import React from 'react';

import { link } from '@aline/routes';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  AlineTabs,
  TabPanel,
  useWorkflowDetailStyles,
  WorkflowBuilderToolbar,
  WorkflowBuilderWorkflow,
} from 'src/components';
import { Apollo } from 'src/gql/generated';
import { useWorkflowParams } from 'src/helpers';

import { CommunitySummaryTabContent } from './detail/CommunitySummaryTabContent';

export function CommunityWorkflowDetailPage(): JSX.Element {
  const { classes } = useWorkflowDetailStyles();
  const { workflowId } = useWorkflowParams();
  const { data } = Apollo.useGetWorkflowNameQuery({ variables: { workflowId } });

  return (
    <>
      <Helmet>
        <title>{data?.workflow?.name ?? 'Community workflow'}</title>
      </Helmet>
      <div className={classes.contentWrapper}>
        <WorkflowBuilderToolbar backRoute={link.CommunityWorkflowIndex()} workflowId={workflowId} />
        <CommunityTemplateTabs />
      </div>
    </>
  );
}

function CommunityTemplateTabs(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { classes } = useWorkflowDetailStyles();
  const { workflowId } = useWorkflowParams();

  return (
    <div className={classes.tabsContainer}>
      <AlineTabs
        tabs={[
          {
            label: 'Summary',
            value: link.CommunityWorkflowDetailTabSummary({ workflowId }),
          },
          {
            label: 'Steps',
            value: link.CommunityWorkflowDetailTabSteps({ workflowId }),
          },
        ]}
        value={location.pathname}
        onChange={value => navigate(value, { replace: true })}
      />
      <TabPanel
        className={classes.tabPanel}
        tabValue={link.CommunityWorkflowDetailTabSummary({ workflowId })}
        value={location.pathname}
      >
        <CommunitySummaryTabContent workflowId={workflowId} />
      </TabPanel>
      <TabPanel
        className={classes.tabPanel}
        tabValue={link.CommunityWorkflowDetailTabSteps({ workflowId })}
        value={location.pathname}
      >
        <WorkflowBuilderWorkflow isReadOnly workflowId={workflowId} />
      </TabPanel>
    </div>
  );
}
